module.exports = __webpack_public_path__ + "static/media/home-hero-background.1f866248.png";